export default __webpack_public_path__ + "cb509fd754466b3e9532d076a7370211.svg";